import { TimeZoneService } from './../../../modules/shared/services/timezone.service';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { PermissionService } from 'src/app/service/permission.service';
import { ObjectNames } from 'src/app/shared/constants';
import { SharedCRMConfigService } from '../../../configurations/crm/shared/services/shared-crm-config.service';
import { AppMainComponent } from '../../../app.main.component';
import { MessageService } from 'primeng/api';
import { AppMainService } from '../../../app-main.service';
import { TemplateSection } from '../../../modules/shared/model/templateSection.model';
import { CASES_FORM_FIELDS } from '../../constants/case-add-edit.constants';
import { ParseHelper } from '../../../modules/shared/parse.helper';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormErrorHandler } from '../../../modules/shared/helpers/form-error-handler.helper';
import { ConfigurationService } from '../../../configurations/configurationService';
import { AccountModuleId, CaseModuleId, LeadModuleId } from '../../../modules/shared/constants/modules.constant';
import { CasesService } from '../../services/cases.service';
import { AccountServiceN } from 'src/app/accounts-v2/services/account.services';
import { GelAllAccountRequestModel } from '../../../accounts-v2/models/account-request.model';
import { LeadServiceN } from 'src/app/leads-v2/services/lead.service';
import { GetAllLeadRequestModel } from 'src/app/leads-v2/model/lead-request.model';
import { LeadService } from '../../../leads/leadService';
import { AccountService } from '../../../accounts/accountService';
import { ContactService } from 'src/app/contacts/contactService';
import { CaseService } from 'src/app/configurations/crm/case/case.service';
import { Category } from '../../../shared/model/category';
// import { LocalDatePipe } from '../shared/pipes/local-date.pipe';
import { LocalDatePipe } from '../../../shared/pipes/local-date.pipe';
import { Status } from '../../../models/statusEnums';
import { CasesAddEditCustomFields } from '../../models/case-add-edit.model';
import { FormControlListIds } from '../../constants/form-control.constant';
import { User } from '../../../modules/shared/model/user.model';
import { HttpErrorResponse } from '@angular/common/http';
import * as saveAs from 'file-saver';
import { uploadFiles, validateFileSize, validateFiles } from '../../../shared/upload-files';
import { casesCustomAttributeAttachment } from '../../models/custom-attachment.model'
import { DatePipe } from '@angular/common';
import { isObject } from '@ngneat/transloco';
import { SharedColumnSettingsService } from 'src/app/modules/shared/services/column-settings.service';
import { ColumnSettingsN } from 'src/app/modules/shared/models/column-settings.model';
@Component({
  selector: 'app-cases-add-edit-dialog',
  templateUrl: './cases-add-edit-dialog.component.html',
  styleUrls: ['./cases-add-edit-dialog.component.scss'],
  providers: [DatePipe, LocalDatePipe]
})
export class CasesAddEditDialogComponent implements OnInit {

  @Input() displayAddEditDialog: boolean = false;
  @Input() accountSelectionDisabled: boolean = false;
  @Input() crudType: 'add' | 'update' | 'clone' | 'view' = 'add';
  @Input() casesChannelId: number;
  @Input() accountChannelId: number;
  @Input() casesId: number;
  @Input() groupUserList: any[] = [];
  @Input() callFromAccountTab: boolean = false;
  @Input() casesChannelList: any[] = [];
  @Input() selectedAccount: any;
  @Output() reloadList = new EventEmitter();
  @Output() closeModal = new EventEmitter();
  selectedTemplate = {id:0};

  //Form Variables
  dialogHeader: 'Add Cases' | 'Edit Cases' | 'Clone Cases' | 'View Cases' = 'Add Cases';

  private ngUnsubscribe$ = new Subject<void>();
  writePermission: boolean;
  editPermission: boolean;
  casesForm: FormGroup;
  // dropdowns
  categories: Category[] = [];
  categoriesList: Category[] = [];
  subCategories: Category[] = [];
  priorities = []
  selectedPriority;
  sources = [];
  pipelineTypeId = null;
  accountList: any[] = [];
  allContactList: any[] = [];
  contactNamesForSuggestions: any[] = [];
  activeUsersList: any[] = [];
  allStagesDropdown: any[] = [];
  caseAssociationList: any[] = [];
  private _allContactList: any = [];
  private _emailAddressSuggestion: any = [];
  emailAddressSuggestion: any = [];
  private _selectedContactName: string;
  private _selctedEmailAddress: string;
  private _selectedPhoneNumber: string;
  associationNamesSuggestions: any[] = [];
  contactNamesSuggestions: any[] = [];

  phoneNumberSuggestion: Array<any>;
  _phoneNumberSuggestion: Array<any>;
  userList: Array<any>;
  // template fields
  noTemplateMessage: string = "";
  templateSections: TemplateSection[] = [];
  checkedFieldList: any = [];
  checkedFields: any = {};
  // case details
  casesDetails: any;
  casesViewDetails: any;
  // cases form fields
  formSubmitted: boolean = false;
  formControlListIds = FormControlListIds;
  isUnsavedData: boolean = false;
  detailsFormErrors: any = {};
  formErrorHandler: FormErrorHandler = new FormErrorHandler();
  resolutionDate: any;

  isShowResComments: boolean = false;
  // login user
  loggedUserDetails: User;

  // ---upload attachment work
  allowedExtensions = ['.pdf', '.csv', '.txt', '.xlsx', '.xls', '.docx', '.doc', '.png', '.jpg', '.jpeg', '.ppt', '.pptx', '.gif', '.zip']; // For the attachment files
  uploadedFiles: any[] = [];
  mimeTypes = [
    { extension: "csv", value: "text/csv;charset=utf-8" },
    { extension: "doc", value: "application/msword;charset=utf-8" },
    { extension: "docx", value: "application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8" },
    { extension: "gif", value: "image/gif;charset=utf-8" },
    { extension: "jpeg", value: "image/jpeg;charset=utf-8" },
    { extension: "jpg", value: "image/jpeg;charset=utf-8" },
    { extension: "png", value: "image/png;charset=utf-8" },
    { extension: "pdf", value: "application/pdf;charset=utf-8" },
    { extension: "ppt", value: "application/vnd.ms-powerpoint;charset=utf-8" },
    { extension: "rar", value: "application/x-rar-compressed;charset=utf-8" },
    { extension: "xls", value: "vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" },
    { extension: "xlsx", value: "vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" },
    { extension: "zip", value: "application/zip;charset=utf-8" },
    { extension: "txt", value: "text/plain;charset=utf-8" }
  ];
  displayFilePreview: boolean;
  currentFile: any;

  detailsLoadingFailed: boolean = false;
  detailsErrorMessage: string = '';
  selectedParentAccount: any;
  accountExistMsg: string = '';
  displayManualPopup: boolean = false;
  manualRuleColumnSetttings: Partial<ColumnSettingsN> = {};
  selectedRecordList: any[] = [];
  allModuleList = [
    { id: AccountModuleId, name: 'Account' },
    { id: LeadModuleId, name: 'Lead' }
  ];

  selectedModule:any;

  constructor(
    private formBuilder: FormBuilder,
    private permissionService: PermissionService,
    private sharedConfigService: SharedCRMConfigService,
    private app: AppMainComponent,
    private messageService: MessageService,
    private appMainService: AppMainService,
    private configurationService: ConfigurationService,
    private casesService: CasesService,
    private accountServiceN: AccountServiceN,
    private leadServiceN: LeadServiceN,
    private leadService: LeadService,
    private accountService: AccountService,
    private contactService: ContactService,
    private caseServiceConfig: CaseService,
    public localDatePipe: LocalDatePipe,
    private datePipe: DatePipe,
    private timeZoneService: TimeZoneService,
    private columnSettingsService: SharedColumnSettingsService
  ) {
    this.loggedUserDetails = this.app.user;
  }

  ngOnInit(): void {
    this.setPermissions();
    this.loadDropdownList();
    this.openCasesAddEdit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.groupUserList?.currentValue) {
      this.groupUserList = changes?.groupUserList?.currentValue;
    }

    if (changes?.casesChannelId?.currentValue) {
      this.casesChannelId = changes?.casesChannelId?.currentValue;
    }

    if (changes?.displayAddEditDialog?.currentValue) {
      this.displayAddEditDialog = changes?.displayAddEditDialog?.currentValue;
    }

    if (changes?.casesId?.currentValue) {
      this.casesId = changes?.casesId?.currentValue;
    }

    if (changes?.accountChannelId?.currentValue) {
      this.accountChannelId = changes?.accountChannelId?.currentValue;
      this.selectedTemplate.id = this.accountChannelId;
    }

    if (changes?.callFromAccountTab?.currentValue) {
      this.callFromAccountTab = changes?.callFromAccountTab?.currentValue;
    }

    if (changes?.selectedAccount?.currentValue) {
      this.selectedAccount = changes?.selectedAccount?.currentValue;
    }

    if(changes?.casesChannelList?.currentValue){
      this.casesChannelList = changes?.casesChannelList?.currentValue;
    }
  }


  // Set permissions for read, write, edit, delete and export
  setPermissions(): void {
    const userPermissions = this.permissionService.getPermissionData();
    if (userPermissions.length) {
      let casesUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CASES);
      const casesLifeCycleStageUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CASES_LIFE_CYCLE_STAGE);
      casesUserPermission = casesUserPermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1);
      this.writePermission = casesUserPermission && (casesUserPermission[1].permissionId == 2 && casesUserPermission[1].statusId == 1) ? true : false;
      this.editPermission = casesUserPermission && (casesUserPermission[2].permissionId == 3 && casesUserPermission[2].statusId == 1) ? true : false;
    }
  }

  loadDropdownList() {
    this.getCaseAssociationList();
    this.getCaseCategoriesList();
    this.getAllTypes();
  }

  getCaseAssociationList() {
    this.casesService.getAllContactAssociation().subscribe({
      next: (assoc) => {
        this.caseAssociationList = assoc.filter(data => data?.name != 'Opportunity');
        if (this.crudType == 'add' && this.callFromAccountTab && !this.casesForm?.getRawValue().caseAssociationName) {
            this.setCaseAssociaiton();
        }
      }
    })
  }


  getCaseCategoriesList() {
    this.caseServiceConfig.getCaseCategories().subscribe(categoriesList => {
      let deafaultCategory: any;
      this.categoriesList = categoriesList;
      this.categories = this.categoriesList.length ? this.categoriesList.filter(categoryObj => categoryObj.parentCategoryId == 0 || categoryObj.parentCategoryId == null) : [];
      deafaultCategory = this.categories.find((data) => {
        return data?.isDefault == true;
      })
      this.subCategories = this.categoriesList?.length ? this.categoriesList.filter((category: Category) => category?.parentCategoryId === deafaultCategory?.id) : [];
    });
  }

  getAllTypes() {
    this.casesService.getAllTypes().subscribe(
      types => {
        this.appMainService.isHideSpinner('loadTypes')
        // this.channelTypeId = types.find(type => type.name == ObjectNames.CHANNEL_TYPE_NAME).id;
        // this.templateTypeId = types.find(type => type.name == ObjectNames.TEMPLATE_TYPE_NAME).id;
        this.pipelineTypeId = types.find(type => type.name == ObjectNames.PIPELINE_TYPE_NAME).id;
        // this.columnSettingTypeId = types.find(type => type.name == ObjectNames.COLUMN_SETTING_TYPE).id;
        this.loadCaseConfiguration();
      },
      err => {
        this.appMainService.isHideSpinner('loadTypes')
      });
  }


  loadCaseConfiguration() {
    this.appMainService.isShowSpinner('caseConfig')
    this.casesService.getCaseConfigurations().subscribe(
      caseConfigs => {
        this.appMainService.isHideSpinner('caseConfig')
        const allCasefield = JSON.parse(caseConfigs.find(s => s.name == ObjectNames.FIELD_CASES_CONFIGURATION && s.typeId == this.pipelineTypeId)?.configurationDetails[0].configJSONValue);

        this.sources = allCasefield.length ? allCasefield.filter(s => s.fieldsType == "Source") : [];
        this.priorities = allCasefield.length ? allCasefield.filter(s => s.fieldsType == "Priority") : [];
        if (this.crudType == 'add') {
          this.sourceSet();
          this.prioritySet();
        }
      },
      err => {
        this.appMainService.isHideSpinner('caseConfig')
      }
    )
  }

  openCasesAddEdit() {
    switch (this.crudType) {
      case 'add':
        this.dialogHeader = 'Add Cases';
        this.getTemplateFormFields();
        break;
      case 'update':
        this.dialogHeader = 'Edit Cases';
        this.getCasesDetails();
        break;
      case 'view':
        this.dialogHeader = 'View Cases';
        this.getCasesDetails();
        this.getActivityList();
        break;
      default:
        break;
    }

  }

  getActivityList() {
    this.app.objectId = this.casesId;
    this.app.objectType = ObjectNames.CASES;
  }


  getCasesDetails() {
    if (this.casesId > 0) {
      this.appMainService.isShowSpinner('getCasesDetails');
      this.detailsLoadingFailed = false;
      this.casesService.getCasesById(this.casesId).subscribe({
        next: (response: any) => {
          this.appMainService.isHideSpinner('getCasesDetails');
          this.casesDetails = response;
          this.casesChannelId = this.casesDetails?.channelId;
          if (this.casesDetails?.account?.typeId) {
            this.accountChannelId = this.casesDetails?.account?.typeId;
          }
          if (this.casesDetails?.associationData?.channelId) {
            this.accountChannelId = this.casesDetails?.associationData?.channelId;
          }
          this.formatCustomFieldValues();
          this.getTemplateFormFields();
        },
        error: (error) => {
          this.appMainService.isHideSpinner('getCasesDetails');
          this.detailsLoadingFailed = true;
          switch (error?.status) {
            case 404:
              this.detailsErrorMessage = "This case might be deleted or You're not permitted to view details!";
              break;
            default:
              this.detailsErrorMessage = 'Error occurring when fetching case details. Please try after sometimes.';
              this.messageService.add({
                severity: 'error',
                summary: 'Error!',
                detail: this.detailsErrorMessage,
              });
              break;
          }
        }
      });
    }
  }


  getTemplateFormFields(): void {
    this.appMainService.isShowSpinner('getTemplateFormFields');
    this.sharedConfigService.getTemplateFormFields(8, this.casesChannelId)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          this.templateSections = response || [];
          this.generateCheckFields();
          this.noTemplateMessage = '';
          this.appMainService.isShowSpinner('getTemplateFormFields');
        },
        error: (() => {
          this.templateSections = [];
          this.noTemplateMessage = 'Error loading template under this channel.';
          this.appMainService.isShowSpinner('getTemplateFormFields');
        }),
        complete: (() => {
          this.appMainService.isHideSpinner('getTemplateFormFields');
        })
      });
  }


  generateCheckFields() {
    const checkFields: any = {};
    const checkedFieldList: any[] = [];
    CASES_FORM_FIELDS.map(section => {
      section.fields.map(fieldDetails => {
        const checkfield = this.templateSections[0].fields.find(field => field.field == fieldDetails.settingFieldName);
        checkFields[fieldDetails.formFieldname] = checkfield ? { ...checkfield, formFieldname: fieldDetails.formFieldname } : {};
        checkedFieldList.push(checkFields[fieldDetails.formFieldname]);
      })
    });
    for (const { name, fields } of this.templateSections) {
      for (const fieldData of fields) {
        if (fieldData.name) {
          if (fieldData.childFields?.length) {
            for (const childFieldData of fieldData.childFields) {
              childFieldData.name = this.processFieldName(
                childFieldData.name
              );
              checkFields[childFieldData.field] = childFieldData;
              checkFields[childFieldData.field]['formFieldname'] = childFieldData.field;
              checkedFieldList.push(checkFields[childFieldData.field]);
            }
          }
        }
      }
    }
    this.checkedFieldList = ParseHelper.DeepCopy(checkedFieldList);
    this.checkedFields = checkFields;
    this.initCasesForm();
    this.generateCustomAttributeFields();
  }

  processFieldName(fieldName: string): string {
    // Removes all parentheses from field name
    fieldName = fieldName.split('(')[0];

    // Removes all dots from field name
    fieldName = fieldName.split('.')[0];

    // Removes all slashes from field name
    fieldName = fieldName.split('/')[0];

    // Removes all spaces from field name
    fieldName = fieldName.split(' ').join('');

    return fieldName;
  }


  initCasesForm() {
    this.detailsFormErrors = {};
    this.isUnsavedData = false;

    this.casesForm = this.formBuilder.group({
      id: [0],
      channelId: [this.casesChannelId, [Validators.required]],
      sequenceNumber: [{ disabled: true, value: "" }, [...this.getValidators(this.checkedFields.sequenceNumber)]],
      caseAssociationName: [{value: null, disabled: this.callFromAccountTab}, [...this.getValidators(this.checkedFields.caseAssociationName)]],
      associationName: [{value: null, disabled: this.callFromAccountTab}, [...this.getValidators(this.checkedFields.associationName)]],
      contactName: [null,[Validators.maxLength(50)]],
      contactEmailAddress: [null, [...this.getValidators(this.checkedFields.contactEmailAddress), Validators.pattern("[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$")]],
      contactMobileNo: [this.phoneNumberSuggestion || null],
      sourceName: [null],
      categoryName: [null],
      subCategoryName: [null],
      priorityName: [null],
      subject: ['',[Validators.maxLength(100)]],
      reportedBy: [this.app.user.userName],
      attachmentLinks: this.formBuilder.array([]),
      ticketDesc: ['', [...this.getValidators(this.checkedFields.resolutionDate)]],
      organizationId: [''],
      sourceId: [''],
      stageId: ['1'],
      resolutionDate: [new Date(), [...this.getValidators(this.checkedFields.resolutionDate)]],
      resolutionComment: ['', []],
      assignedGroup: [null, [...this.getValidators(this.checkedFields.assignedGroup)]],
      assignedUser: [null],
      customAttributeValues: this.formBuilder.array([]),
    });
    this.formErrorHandler.handleErrors(this.casesForm, this.detailsFormErrors, {
      sequenceNumber: {
        required: "Serial No. not loaded, please reload any try again."
      },
      caseAssociationName: {
        required: `Select ${this.checkedFields?.caseAssociationName?.labelName}`,
      },
      associationName: {
        required: `Select ${this.checkedFields?.associationName?.labelName}`,
      },
      resolutionDate: {
        required: `Select ${this.checkedFields?.resolutionDate?.labelName}`,
      },
      assignedGroup: {
        required: `Select ${this.checkedFields?.assignedGroup?.labelName}`,
      },
      resolutionComment: {
        required: `Enter ${this.checkedFields?.resolutionComment?.labelName}`,
      },
      ticketDesc: {
        required: `Enter ${this.checkedFields?.ticketDesc?.labelName}`,
      },
      contactEmailAddress: {
        required: `Enter ${this.checkedFields.contactEmailAddress?.labelName}`,
        pattern: "Enter a valid email"
      },
      channelId: {
        required: `Select Cases Channel`,
      },
      subject: {
        maxlength: `${this.checkedFields.subject?.labelName} should be less than 100 words`
      },
      contactName: {
        maxlength: `${this.checkedFields.contactName?.labelName} should be less than 50 words`
      }
    });

    // this.setDefaultStage();

    if (this.crudType == 'add') {
      this.generateSequenceNumber();
      this.categorySet();
      this.subCategorySet();
    }

    if (this.crudType == 'add' && this.callFromAccountTab) {
        this.setCaseAssociaiton();
        this.setFieldsFromAccountsTab();
    }

    if (this.crudType !== 'add') {
      this.setCasesFormDetails();
      this.generateCasesView();
      this.setEmailValidatorOnEdit();
    }
  }

  selectedCasesChannel(selectedCasesChannel){
    if(selectedCasesChannel){
      this.casesChannelId = selectedCasesChannel;
      this.crudType = 'add';
      this.loadDropdownList();
      this.openCasesAddEdit();
      // this.getTemplateFormFields();
    }
  }

  setCaseAssociaiton(){
    this.casesForm?.patchValue({
        caseAssociationName: this.caseAssociationList?.find(data => data?.name == 'Account')
    });
  }

  setFieldsFromAccountsTab() {
    this.casesForm?.patchValue({
      associationName: {id: this.selectedAccount.id, businessName: `${this.selectedAccount?.sequenceNumber} -  ${this.selectedAccount?.businessName}`},
    });

    this.accountService.getAccountContactNameList(this.selectedAccount?.id).subscribe(res => {
      this._allContactList = res.map((el) => el.contact);
      this.setContactNameFromApi();
      this.setEmailAddress();
      this.setPhoneNumber();
    });
  }

  setEmailValidatorOnEdit() {
    if (this.casesForm.get('contactEmailAddress').value != null) {
      this.contactEmail.clearValidators();
      this.contactEmail.updateValueAndValidity();
    }
  }

  categorySet() {
    this.casesForm.get('categoryName').setValue(this.categories.find((data) => {
      return data?.isDefault;
    }));
    this.categories = this.categories.filter((data) => { return data?.isActive == true });
  }

  subCategorySet() {
    this.subCategories = this.subCategories.filter((data) => { return data?.isActive == true });
    const selectedSubCategory: any = this.subCategories ? this.subCategories.find((data) => {
      return data?.isDefault == true
    }) : [];
    if (selectedSubCategory) {
      this.casesForm.get('subCategoryName').setValue(selectedSubCategory);
      this.getResolutionDate(selectedSubCategory?.resolutionDays);
      this.getSelectedUserGroup(selectedSubCategory);
    }
    else {
      this.casesForm.patchValue({ resolutionDate: new Date() });
    }
  }

  sourceSet() {
    this.casesForm.get('sourceName').setValue(this.sources.find((data) => {
      return data?.isDefault;
    }));
    this.sources = this.sources.filter((data) => { return data?.isActive == true });
  }

  prioritySet() {
    this.casesForm.get('priorityName').setValue(this.priorities.find((data) => {
      return data?.isDefault;
    }));
    this.priorities = this.priorities.filter((data) => { return data?.isActive == true });
  }

  getValidators(fieldData: any): any[] {
    const validators: any[] = [];

    if (fieldData?.enabledInForm && fieldData?.isRequired) {
      validators.push(Validators.required);
    }

    if (fieldData?.enabledInForm && fieldData?.isRequired) {
      validators.push(Validators.required);
    }

    return validators;
  }

  generateSequenceNumber() {
    this.configurationService.generateSequenceNumberByModuleId(CaseModuleId).subscribe((response) => {
      this.casesForm.get('sequenceNumber').setValue(response);
    });
  }

  closeCasesDialog() {
    this.displayAddEditDialog = false;
    this.closeModal.emit();
  }


  getContactsValues(value, caseAssociation?, setName = false) {
    const currentCaseAssociation: any = caseAssociation ? caseAssociation : this.casesForm.getRawValue().caseAssociationName;
    if (currentCaseAssociation && currentCaseAssociation.name == "Lead") {
      this.leadService.getLeadById(value.id).then(res => {
        this._allContactList = res && res.leadContacts ? res.leadContacts.map((el) => el.contact) : [];
        // if (setName) {
        this.setContactNameFromApi();
        this.setEmailAddress();
        this.setPhoneNumber();
        // }
      });

    } else if (currentCaseAssociation && currentCaseAssociation.name == "Account") {
      this.accountService.getAccountContactNameList(value.id).subscribe(res => {
        this._allContactList = res.map((el) => el.contact);
        // if (setName) {
        this.setContactNameFromApi();
        this.setEmailAddress();
        this.setPhoneNumber();
        // }
      })

    } else if (currentCaseAssociation && currentCaseAssociation.name == "Organization") {
      //this._allContactList = this.orgContacts;
      this.contactService.getContactByAssociation(this.app.user.organizationId).subscribe((response) => {
        this._allContactList = response;
        // if (setName) {
        this.setContactNameFromApi();
        this.setEmailAddress();
        this.setPhoneNumber();
        // }
      },
        (error) => {

        });
    }
    else if (currentCaseAssociation && currentCaseAssociation.name == "Product") {
      if (setName) {
        this.setContactNameFromApi();
      }
    }
  }

  //set contactname while showing preloaded values on edit popup
  private setContactNameFromApi() {
    if (this._allContactList.length && this._selectedContactName) {
      let selectedContact = this._allContactList.length ? this._allContactList.find(contact => contact != null && ((contact.associationName == this._selectedContactName) || (contact.name == this._selectedContactName) || (`${contact.firstName} ${contact.lastName}` == this._selectedContactName))) : null;
      selectedContact = selectedContact ? selectedContact : { name: this._selectedContactName, id: 0 };
      if (selectedContact) {
        selectedContact.contactName = selectedContact.name ? selectedContact.name : selectedContact.firstName + ' ' + selectedContact.lastName;
        this.casesForm.patchValue({ contactName: selectedContact })
      }
    } else {
      //if contact name is manually
      if (this._selectedContactName) {
        this._allContactList = [{ contactName: this._selectedContactName, name: this._selectedContactName, id: 0 }];
        this.casesForm.patchValue({ contactName: { contactName: this._selectedContactName, name: this._selectedContactName, id: 0 } });
      }
    }
  }

  setEmailAddress() {
    if (this._emailAddressSuggestion?.length > 0 && this._selctedEmailAddress) {
      let selectedEmail = this._emailAddressSuggestion.find(x => x?.emailAddress == this._selctedEmailAddress);
      if (selectedEmail) {
        this.casesForm.patchValue({ contactEmailAddress: selectedEmail });
      }
      else {
        this.casesForm.patchValue({ contactEmailAddress: { emailAddress: this._selctedEmailAddress, name: this._selctedEmailAddress, id: 0 } });
      }
      // if (this.casesForm.get('contactEmail').value != null) {
      //     this.contactEmail.clearValidators();
      //     this.contactEmail.updateValueAndValidity();
      // }
    }
    // When Email Address Enterted Manually
    else {
      if (this._selctedEmailAddress) {
        this.casesForm.patchValue({ contactEmailAddress: { emailAddress: this._selctedEmailAddress, name: this._selctedEmailAddress, id: 0 } });
        // if (this.casesForm.get('contactEmail').value != null) {
        //     this.contactEmail.clearValidators();
        //     this.contactEmail.updateValueAndValidity();
        // }
      }
    }
  }

  setPhoneNumber() {
    if (this._phoneNumberSuggestion?.length > 0 && this._selectedPhoneNumber) {
      let selectedPhone = this._phoneNumberSuggestion.find(x => x?.number == this._selectedPhoneNumber);
      if (selectedPhone) {
        this.casesForm.patchValue({ contactMobileNo: selectedPhone });
      }
      else {
        this.casesForm.patchValue({ contactMobileNo: { number: this._selectedPhoneNumber, name: this._selectedPhoneNumber, id: 0 } });
      }
    }
    // When Phone Number Enterted Manually
    else {
      if (this._selectedPhoneNumber) {
        this.casesForm.patchValue({ contactMobileNo: { number: this._selectedPhoneNumber, name: this._selectedPhoneNumber, id: 0 } });
      }
    }
  }

  getAssociationNames(event) {
    this.casesForm.patchValue({
      associationName: null
    });
  }

  search(query) {
    let currentCaseAssociation = this.casesForm.getRawValue().caseAssociationName;
    switch (currentCaseAssociation?.name) {
      case 'Organization':
        this.associationNamesSuggestions = [{ id: this.app.user.organizationId, businessName: this.app.user.organizationName }];
        break;
      case 'Lead':
        if (query) {
          this.searchLeads(query);
        } else {
          this.associationNamesSuggestions = [];
        }
        break;
      case 'Account':
        if (query) {
          this.searchAccounts(query);
        } else {
          this.associationNamesSuggestions = [];
        }
        break;
      default:
        const filtered: any[] = [];
    }
  }

  searchAccounts(accountName: string = "") {
    const requestModel: GelAllAccountRequestModel = {
        channelId: this.accountChannelId,
        stageId: null,
        isActive: true,
        globalSearchValue: accountName,
        selectableColumns: [
            {columnName: "businessName",isCustom: false},
            {columnName: "sequenceNumber",isCustom: false},
            {columnName: "nameWithSequenceNumber",isCUstom: false}
        ],
        filter: null,
        pageSize: 0,
        pageNumber: 0,
        sortByColumn: null,
        isSortByDescending: true,
        filterInColumns: []
    }

    this.appMainService.isShowSpinner('getAccountList');

    this.accountServiceN.getAccountsList(requestModel)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          if (response) {
            this.associationNamesSuggestions = response?.list?.length > 0 ? response?.list.slice(0, 1000) : [];
            this.associationNamesSuggestions = this.associationNamesSuggestions.map(list=> ({...list, businessName: list.nameWithSequenceNumber}));
          }
          if (!this.associationNamesSuggestions.length) {
            this.associationNamesSuggestions.push({ businessName: 'No Data found.', errorId: 1 });
          }
          this.appMainService.isHideSpinner('getAccountList');
        },
        error: (error) => {

          this.appMainService.isHideSpinner('getAccountList');
        },
        complete: () => {
          this.appMainService.isHideSpinner('getAccountList');

        }
      })
  }


  searchLeads(leadName: string = "") {
    const requestModel: GetAllLeadRequestModel = {
      channelId: this.accountChannelId,
      stageId: null,
      isActive: true,
      globalSearchValue: leadName,
      selectableColumns: [{
        columnName: "businessName",
        isCustom: false
      }],
      filter: null,
      pageSize: 0,
      pageNumber: 0,
      sortByColumn: null,
      isSortByDescending: true,
      filterInColumns: []
    }
    this.appMainService.isHideSpinner('getAllLeads');
    this.leadServiceN.getLeadsList(requestModel)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          if (response) {
            this.associationNamesSuggestions = response?.list?.length > 0 ? response?.list.slice(0, 1000) : [];
          }
          if (!this.associationNamesSuggestions.length) {
            this.associationNamesSuggestions.push({ businessName: 'No Data found.', errorId: 1 });
          }
          this.appMainService.isHideSpinner('getAllLeads');
        },
        error: (error) => {
          this.appMainService.isHideSpinner('getAllLeads');
        },
        complete: () => {
          this.appMainService.isHideSpinner('getAllLeads');
        }
      })

  }

  // --------search contact
  searchContact(query) {
    const filtered: any[] = [];
    if (this._allContactList.length) {
      for (let i of this._allContactList) {
        let associationName = i;
        associationName.contactName = associationName?.name ? associationName?.name : associationName?.firstName + ' ' + associationName?.lastName;
        if (associationName.contactName.toLowerCase().indexOf(query.toLowerCase()) !== -1) {
          filtered.push(associationName);
        }
      }
    }
    this.contactNamesSuggestions = filtered.length ? [...filtered] : [];
  }

  getContactsDetails(value) {
    // this.addForm.patchValue({
    //     contactEmail:  value.contactEmails && value.contactEmails[0] && value.contactEmails[0].email && value.contactEmails[0].email.emailAddress ? value.contactEmails[0].email.emailAddress: ''
    // })
    // this.addForm.patchValue({
    //     contactPhone: value.contactPhones && value.contactPhones[0] && value.contactPhones[0].phone && value.contactPhones[0].phone.number ? value.contactPhones[0].phone.number: ''
    // })

    // Auto binding when get only one email

    // if (value.contactEmails.length == 1){
    //     // this.addForm.patchValue({
    //     // contactEmail:  value.contactEmails && value.contactEmails[0] && value.contactEmails[0].email && value.contactEmails[0].email.emailAddress ? value.contactEmails[0].email.emailAddress: ''
    //     // });
    //     this.addForm.patchValue({contactEmail: {emailAddress: value.contactEmails[0].email.emailAddress, name: value.contactEmails[0].email.emailAddress, id: 0}});
    //     if (this.addForm.get('contactEmail').value != null){
    //         this.contactEmail.clearValidators();
    //         this.contactEmail.updateValueAndValidity();
    //     }
    // }


    this._emailAddressSuggestion = [];
    this._phoneNumberSuggestion = [];
    if (value?.contactEmails?.length > 0) {
      this.casesForm.patchValue({ contactEmailAddress: '' });
      const values = [];
      //let counter = 0;
      for (let i of value.contactEmails) {
        values.push(i?.email);
        // if (values[counter].emailType?.name == 'Work Email'){
        //     this.addForm.patchValue({
        //         contactEmail:  {emailAddress: values[counter]?.emailAddress, name: values[counter]?.emailAddress, id: 0}
        //     });
        //     if (this.addForm.get('contactEmail').value != null){
        //         this.contactEmail.clearValidators();
        //         this.contactEmail.updateValueAndValidity();
        //     }
        // }
        // counter++;
      }
      this._emailAddressSuggestion = values;
    }
    else {
      this.casesForm.patchValue({ contactEmail: '' });
    }

    // Auto binding when get only one phone

    // if (value.contactPhones.length == 1){
    //     this.addForm.patchValue({
    //         contactPhone: {phone: value.contactPhones[0].phone.number, name: value.contactPhones[0].phone.number, id: 0}
    //     });
    // }
    if (value.contactPhones.length > 0) {
      this.casesForm.patchValue({ contactPhone: '' });
      const values = [];
      //let counter = 0;
      for (let i of value.contactPhones) {
        values.push(i?.phone);
        // if (values[counter].phoneType?.name == 'Work Phone'){
        //     this.addForm.patchValue({
        //         contactPhone:  {number: values[counter]?.number, name: values[counter]?.number, id: 0}
        //     });

        // }
        // counter++;
      }
      this._phoneNumberSuggestion = values;
    }
    else {
      this.casesForm.patchValue({ contactPhone: '' });
    }
  }

  searchEmailAddress(query) {
    const filtered: any[] = [];
    if (this._emailAddressSuggestion.length) {
      this.contactEmail.addValidators(Validators.pattern("[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"));
      this.contactEmail.updateValueAndValidity();
      for (let i of this._emailAddressSuggestion) {
        let email = i;
        if (email?.emailAddress?.toLowerCase().indexOf(query.toLowerCase()) !== -1) {
          filtered.push(email);
        }
      }
    }
    this.emailAddressSuggestion = filtered.length ? [...filtered] : [];
  }


  getEmailValues(value): void {
    if (value.emailAddress != null) {
      this.casesForm.patchValue({ contactEmail: { emailAddress: value.emailAddress, name: value.emailAddress, id: 0 } });
      if (this.casesForm.get('contactEmailAddress').value != null) {
        this.contactEmail.clearValidators();
        this.contactEmail.updateValueAndValidity();
      }
    }
  }


  searchPhoneNumber(query) {
    const filtered: any[] = [];
    if (this._phoneNumberSuggestion?.length) {
      for (let i of this._phoneNumberSuggestion) {
        let phone = i;
        if (phone?.number?.indexOf(query.toLowerCase()) !== -1) {
          filtered.push(phone);
        }
      }
    }
    this.phoneNumberSuggestion = filtered.length ? [...filtered] : [];
  }

  getPhoneNumberValues(value): void {
    if (value.contactPhones != null) {
      this.casesForm.patchValue({ contactMobileNo: { number: value.number, name: value.number, id: 0 } });

    }
  }




  getSubCategories(event) {
    if (event?.value?.parentCategoryId == null) {
      this.subCategories = this.categoriesList.filter((data) => {
        return data?.parentCategoryId == event?.value?.id
      })
    }
    const selectedSubCategory: any = this.subCategories ? this.subCategories.find((data) => {
      return data?.name == event?.value?.name
    }) : [];
    if (selectedSubCategory) {
      this.getSelectedUserGroup(selectedSubCategory);
      this.getResolutionDate(selectedSubCategory?.resolutionDays);
    }
    else {
      this.casesForm.patchValue({ resolutionDate: new Date() });
    }
  }

  getSelectedUserGroup(selectedSubCategory: any): void {
    // this.userGroups = this.groupUserList;
    let selectedGroup = this.groupUserList ? this.groupUserList.find(x => x.id == selectedSubCategory?.userGroupId) : [];
    this.casesForm.patchValue({ assignedGroup: selectedGroup });

    this.userList = selectedGroup?.users;

    const selectedUser = selectedGroup?.users?.length>0 ? selectedGroup?.users.find(x => x.id == selectedSubCategory?.defaultUserId) : null;
    this.casesForm.patchValue({ assignedUser: selectedUser||null });
  }

  onSelectedUserGroup(event) {
    if (event?.value) {
      let selectedGroup = this.groupUserList.find(x => x.id == event?.value?.id);
      if (selectedGroup) {
        this.casesForm.patchValue({ assignedGroup: selectedGroup });
        this.casesForm.patchValue({ assignedUser: null });
        this.userList = selectedGroup?.users;
      }
    }
  }

  onSelectedUser(event) {
    if (event?.value) {
      this.casesForm.patchValue({ assignedUser: event?.value });
    }
  }


  getResolutionDate(resolutionDays: number): void {
    if (resolutionDays != null) {
      this.casesService.getResolutionDays(resolutionDays).subscribe((response) => {
        //const resolutionDay = new Date(response);
        const resolutionDay = this.localDatePipe.transform(response, 'MM/DD/YYYY',false);
        this.resolutionDate = new Date(response);
        this.casesForm.patchValue({ resolutionDate: resolutionDay });
      },
        (error) => {

        })
    }
  }

  detectDateChange($event): void {
    let changeDate = new Date($event);
    if (changeDate.getTime() > this.resolutionDate.getTime()) {
      this.isShowResComments = true;
      this.getResoltionDate.addValidators(Validators.required);
      this.getResoltionDate.updateValueAndValidity();
    }
    else {
      this.casesForm.patchValue({ resolutionComment: '' });
      this.getResoltionDate.clearValidators();
      this.getResoltionDate.updateValueAndValidity();
      this.isShowResComments = false;
    }
  }

  get getResoltionDate() {
    return this.casesForm.get('resolutionComment');
  }

  get contactEmail() {
    return this.casesForm.get('contactEmailAddress');
  }

  get getCaseAssociationName() {
    return this.casesForm.get('caseAssociationName');
  }

  uploadAttachments(files: File[]) {
    this.appMainService.isShowSpinner('upload');
    if (typeof Worker !== undefined) {
      //  let errors = validateTotalFileSize(files, 25);
      for (let file of files) {
        let errors = validateFiles(file, 25, this.allowedExtensions);

        if (errors.length > 0) {
          for (let error of errors) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error.fileName + ": " + error.error
            });
          }

          this.appMainService.isHideSpinner('upload');
        } else {
          // this.newFileList.push(file);
          uploadFiles(file, ({ name, content, size, extension }) => {
            let attachmentObj: any = {
              "id": 0,
              "createdSource": this.app.user.userIP,
              "updatedSource": this.app.user.userIP,
              "createdBy": this.app.user.userId,
              "updatedBy": this.app.user.userId,
              "createdDate": new Date(),
              "updatedDate": new Date(),
              "name": name,
              "guidName": "string",
              "location": "string",
              "content": content,
              "extension": extension,
              "sizeInBytes": size,
              "description": "string",
              "statusId": Status.Active,
              "isValid": true,
              "validFromDate": null,
              "validToDate": null
            };

            this.uploadedFiles.push(attachmentObj);
            this.attachments.push(this.formBuilder.group(attachmentObj));
            this.appMainService.isHideSpinner('upload');
          });
        }
      }
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please update the browser. Web Workers are not supported in the older versions of this browser." });
    }

  }

  get attachments(): FormArray {
    return <FormArray>this.casesForm.controls.attachmentLinks;
  }

  downloadFile(name: string, content: string, locationUrl: string) {
    let ext = name.substring(name.lastIndexOf('.') + 1);

    let mime_type = this.mimeTypes.filter(el => el.extension === ext);
    if (mime_type.length > 0 && content) {
      const base64 = content;
      const mime = mime_type[0].value;
      const blob = this.dataURItoBlob(base64, mime);
      const file = new File([blob], name, { type: mime });
      saveAs(file, name)
    } else {
      window.open(locationUrl);
    }
  }

  dataURItoBlob(dataURI: string, mimeType: string) {
    const kept = dataURI.split(",", 2);
    const byteString = atob(kept[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: mimeType });
    return blob;
  }


  openFilePreview(file: any): void {
    this.displayFilePreview = true;
    this.currentFile = file;
  }

  closeFilePreview() {
    this.displayFilePreview = false;
  }

  removeAttachment(data) {
    // this.uploadedFiles.slice(0,i)
    // const attachmentObj = {...this.defaultAttachmentObj, statusId: Status.Deleted}
    // this.addForm.patchValue({attachments: attachmentObj});
    // this.uploadedFiles;
    // this.uploadedFiles = this.uploadedFiles.splice(data.id, 1);
    // this.attachments.removeAt(data.id);
    // this.addForm;
    //this.addForm.patchValue({attachments: this.uploadedFiles});

    let removableIndex = this.uploadedFiles.indexOf(data);
    if (removableIndex >= 0) {
      this.uploadedFiles.splice(removableIndex, 1);
      this.attachments.removeAt(removableIndex);
    }
  }


  saveCases(type: 'view' | 'save' = 'save') {
    if (this.casesForm.invalid) {
      this.casesForm.markAllAsTouched();
      this.casesForm.markAsDirty();
      this.formErrorHandler.showErrorOnSubmit();
      this.scrollToError();
      return;
    }
    this.appMainService.isShowSpinner('saveCase');
    this.formSubmitted = true;
    const formValue = this.casesForm.getRawValue();
    const caseData = this.getPreparedData(ParseHelper.DeepCopy(formValue));
    if (isObject(formValue?.contactMobileNo)) {
      if (this.isNotNullUndefined(formValue?.contactMobileNo?.number)) {
        let number = formValue?.contactMobileNo?.number
        caseData.contactMobileNo = number;
      } else {
        caseData.contactMobileNo = null;
      }
    } else {
      if (this.isNotNullUndefined(formValue?.contactMobileNo)) {
        caseData.contactMobileNo = formValue?.contactMobileNo;
      } else {
        caseData.contactMobileNo = null;
      }
    }
    if (this.crudType == 'add') {
      caseData.sequenceNumber = null;
      caseData.updatedBy = null;
      caseData.updatedDate = null;
      caseData.stageId = 1;
    } else {
      caseData.stageId = this.casesDetails?.stageId;
      if (caseData.contactName.contactName == '') {
        caseData.contactName = null;
      }
    }
    if (this.casesForm.getRawValue().id > 0) {
      this.casesService.updateCase(caseData).subscribe({
        next: (resp) => {
          this.appMainService.isHideSpinner('saveCase');
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Case saved successfully...' });
          this.reloadList.emit(resp);
          this.formSubmitted = false;
          this.uploadedFiles = [];
          this.isShowResComments = false;
          if (type == 'view') {
            this.casesId = resp.id;
            this.crudType = 'view';
            this.openCasesAddEdit();
          } else {
            this.closeCasesDialog();
          }
          this.casesForm.reset();
        },
        error: (err: HttpErrorResponse) => {
          this.formSubmitted = false;
          this.appMainService.isHideSpinner('saveCase');
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.Message })
        }
      });
    } else {
      this.casesService.addCase(caseData).subscribe({
        next: (resp) => {
          this.appMainService.isHideSpinner('saveCase');
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Case saved successfully...' });
          this.reloadList.emit(resp);
          this.formSubmitted = false;
          this.uploadedFiles = [];
          if (type == 'view') {
            this.casesId = resp.id;
            this.crudType = 'view';
            this.openCasesAddEdit();
          } else {
            this.closeCasesDialog();
          }
          this.casesForm.reset();
          this.isShowResComments = false;
        },
        error: (err: HttpErrorResponse) => {
          this.formSubmitted = false;
          if (err?.error?.errors?.associationNameId[0]) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: "Association name is not valid"
            })
            this.appMainService.isHideSpinner('saveCase');
          }
          else if (err?.error?.errors?.contactMobileNo[0]) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: "Length must be upto 12 characters"
            })
            this.appMainService.isHideSpinner('saveCase');
          }
          else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: err?.error?.Message
            })
            this.appMainService.isHideSpinner('saveCase');
          }
        }
      });
    }

  }

  private getPreparedData(data) {
    let conName:any;
    conName = this.contactNameSet(data);
    return {
      id: data?.id || 0,
      createdSource: data?.createdSource || 'Web',
      updatedSource: data?.updatedSource || 'Web',
      createdBy: data?.createdBy || this.app.user.userId,
      updatedBy: data?.updatedBy || this.app.user.userId,
      createdDate: data?.createdDate || new Date(),
      updatedDate: data?.updatedDate || new Date(),
      sourceId: data?.sourceName?.id || null,
      associationName: data?.associationName?.businessName || null,
      organizationId: data?.organizationId || this.app.user.organizationId,
      statusId: data?.statusId || Status.Active,
      subCategoryId: data.subCategoryName?.id || null,
      ticketDesc: data?.ticketDesc || '',  ///need to check
      contactMobileNo: null,  ///need to check
      // contactName: this.crudType == 'add' ? (data.contactName?.associationName != null ? data.contactName?.associationName : data.contactName || null) : (data?.contactName?.contactName ? (data?.contactName?.contactName || null) : (data?.contactName || null)),
      contactName: conName,
      contactEmailAddress: data?.contactEmailAddress?.emailAddress != null ? data?.contactEmailAddress?.emailAddress : data.contactEmailAddress || null,  ///need to check
      userGroupId: data?.assignedGroup?.id || null,
      attachments: data?.attachmentLinks || null,
      fileAttachmentId: data?.fileAttachmentId || null,
      associationNameId: data?.associationName.id || null,
      caseAssociationId: data?.caseAssociationName.id,
      priorityId: data?.priorityName?.id,
      ticketNo: data?.ticketNo || null,  // need to ask
      typeId: data?.typeId || null,  // need to ask
      categoryId: data?.categoryName?.id || null,
      stageId: data?.stageId || 1,  // need to ask
      userId: data?.assignedUser?.id || null,
      isValid: data?.isValid || true,
      validFromDate: data?.validFromDate || null,
      validToDate: data?.validToDate || null,
      caseAssociationName: data?.caseAssociationName?.name || null,
      channelId: this.casesChannelId || 0,
      subject: data?.subject || '',
      reportedBy: data?.reportedBy || '',
      sequenceNumber: data?.sequenceNumber, //sequenceNumber
      resolutionDate: this.datePipe.transform(data?.resolutionDate, 'MM/dd/yyyy'),
      resolutionComment: data?.resolutionComment || null,
      customAttributeValues: data.customAttributeValues && data.customAttributeValues.length > 0 ? this.modifyCustumAttributes(data.customAttributeValues) : null,
      sourceName: data?.sourceName?.name || null,
      priorityName: data?.priorityName?.name || null,
    }
  }

  contactNameSet(data): string | null {
    if (this.crudType == 'add') {
      if (data?.contactName) {
        if (data?.contactName?.contactName) {
          return data?.contactName?.contactName;
        } else {
          return data?.contactName;
        }
      } else if (data.contactName?.associationName) {
        return data.contactName?.associationName
      } else {
        return null;
      }
    } else {
      if (data?.contactName?.contactName) {
        return data?.contactName?.contactName || null;
      } else {
        return data?.contactName || null;
      }
    }
  }

  isNotNullUndefined(data: any) {
    if (data == null || data == undefined || data == '') {
      return false;
    } else {
      return true;
    }
  }

  modifyCustumAttributes(data) {
    const modifiedVAlues = [...data];
    modifiedVAlues.forEach(element => {
      if (element['customAttribute'] && element['customAttribute']['pickListValues']) {
        element['customAttribute']['pickListValues'] = JSON.stringify(element['customAttribute']['pickListValues']);
      }
      if (element.customAttribute.formControl.name == "DatePicker") {
        element.value = element.value != "" ? this.timeZoneService._getCustomDateString(element.value) : element.value;
      }
    });
    return modifiedVAlues;
  }

  //Custom Attributes

  generateCustomAttributeFields() {
    if (this.templateSections?.length > 0) {
      const todayUTCDate = new Date().toISOString();

      this.templateSections[0]?.customFields?.filter(f => f.enabledInForm).map(customField => {

        let pickListValues: any[] = customField?.formControl?.pickListValues || [];

        if ([FormControlListIds.DropDownList, FormControlListIds.MultipleDropDownList].includes(customField?.formControl.id)) {
          pickListValues = customField?.formControl?.pickListValues?.map(x => { return { name: x } }) || [];
        }

        let addedCustomField: CasesAddEditCustomFields = null;

        // need to check
        if (this.casesDetails?.customAttributeValues?.length > 0) {
          addedCustomField = this.casesDetails?.customAttributeValues.find(x => x?.customAttributeId == customField?.customAttributeId);
        }

        if (addedCustomField && addedCustomField?.multipleCheckBox?.length > 0) {
          const availableAddedValues = [];
          addedCustomField.multipleCheckBox.map(pickName => {
            const exist = pickListValues.find(p => p == pickName);
            if (exist) availableAddedValues.push(exist);
          });
          addedCustomField.multipleCheckBox = availableAddedValues?.length > 0 ? availableAddedValues : null;
        }

        if (addedCustomField && addedCustomField?.multipleValues?.length > 0) {
          const availableAddedValues = [];
          addedCustomField.multipleValues.map(list => {
            const multi = pickListValues.find(p => p?.name == list?.name);
            if (multi) availableAddedValues.push(multi);
          });
          addedCustomField.multipleValues = availableAddedValues?.length > 0 ? availableAddedValues : null;
        }

        const fieldDetails: CasesAddEditCustomFields = {
          id: addedCustomField ? addedCustomField.id : 0,
          objectId: CaseModuleId,
          objectValue: this.casesDetails ? this.casesDetails.id : 0,
          customAttribute: { ...customField, formControl: { ...customField.formControl, name: customField.formControl.type, type: null } },
          customAttributeId: customField.customAttributeId,
          formControlId: customField.formControl.id,
          isRequired: customField.isRequired,
          field: customField.field,
          labelName: customField.labelName,
          pickListValues: pickListValues,
          value: addedCustomField?.value || "",
          values: addedCustomField?.values || null,
          multipleValues: addedCustomField?.multipleValues || null,
          multipleCheckBox: addedCustomField?.multipleCheckBox || null,
          ratingId: addedCustomField?.ratingId || 0,
          toggle: addedCustomField?.toggle || false,
          customeAttachement: addedCustomField?.customeAttachement || null,
          createdSource: addedCustomField?.createdSource || this.loggedUserDetails.userIP,
          updatedSource: this.loggedUserDetails.userIP,
          createdBy: addedCustomField?.createdBy || this.loggedUserDetails.userId,
          updatedBy: this.loggedUserDetails.userId,
          createdDate: addedCustomField?.createdDate || todayUTCDate,
          updatedDate: todayUTCDate
        }

        this.addCustomAttribute(fieldDetails);
      })
    }
  }

  initCustomAttribute(customAttribute: CasesAddEditCustomFields) {
    const todayUTCDate = new Date().toISOString();

    const attachmentControlId = [FormControlListIds.Picture, FormControlListIds.FileUpload].includes(customAttribute.formControlId) ? customAttribute.formControlId : FormControlListIds.FileUpload;
    const inputControlId = [FormControlListIds.InputBox, FormControlListIds.DatePicker, FormControlListIds.RadioButton].includes(customAttribute.formControlId) ? customAttribute.formControlId : FormControlListIds.InputBox;

    return this.formBuilder.group({
      id: [customAttribute.id],
      objectId: [customAttribute.objectId],
      objectValue: [customAttribute.objectValue],
      customAttribute: [customAttribute.customAttribute],
      customAttributeId: [customAttribute.customAttributeId],
      formControlId: [customAttribute.formControlId],
      field: [customAttribute.field],
      labelName: [customAttribute.labelName],
      isRequired: [customAttribute.isRequired],
      pickListValues: [customAttribute.pickListValues],
      value: [customAttribute.value, [...this.getCustomValidators(customAttribute, inputControlId)]],
      values: [customAttribute.values, [...this.getCustomValidators(customAttribute, FormControlListIds.DropDownList)]],
      multipleValues: [customAttribute.multipleValues, [...this.getCustomValidators(customAttribute, FormControlListIds.MultipleDropDownList)]],
      multipleCheckBox: [customAttribute.multipleCheckBox, [...this.getCustomValidators(customAttribute, FormControlListIds.CheckBox)]],
      ratingId: [customAttribute.ratingId, [...this.getCustomValidators(customAttribute, FormControlListIds.Rating)]],
      toggle: [customAttribute.toggle, [...this.getCustomValidators(customAttribute, FormControlListIds.ToggleButton)]],
      customeAttachement: [customAttribute.customeAttachement, [...this.getCustomValidators(customAttribute, attachmentControlId)]],
      statusId: [Status.Active],
      createdSource: [customAttribute?.createdSource || this.loggedUserDetails.userIP],
      updatedSource: [this.loggedUserDetails.userIP],
      createdBy: [customAttribute?.createdBy || this.loggedUserDetails.userId],
      updatedBy: [this.loggedUserDetails.userId],
      createdDate: [customAttribute?.createdDate || todayUTCDate],
      updatedDate: [todayUTCDate],
    });
  }

  formatCustomFieldValues() {
    this.casesDetails.customAttributeValues.map((element: any) => {
      if (element.customAttribute && element.customAttribute.formControl && element.customAttribute.formControl.name) {

        element['formControlId'] = element.customAttribute.formControl.id;
        element['field'] = element.customAttribute.formControl.fieldName;

        switch (element.customAttribute.formControl.name) {
          case 'DropDownList':
            element.values = element.value ? JSON.parse(element.value) : null;
            break;
          case 'MultipleDropDownList':
            element.multipleValues = element.value ? JSON.parse(element.value) : null;
            break;
          case 'CheckBox':
            element.multipleCheckBox = element.value ? JSON.parse(element.value) : null;
            break;
          case 'FileUpload':
            element.customeAttachement = element.value ? JSON.parse(element.value) : null;
            break;
          case 'Picture':
            element.customeAttachement = element.value ? JSON.parse(element.value) : null;
            break;
          case 'DatePicker':
            element.value = element.value ? new Date(element.value) : '';
            break;
          case 'Rating':
            element.ratingId = element.value ? parseInt(element.value) : 0;
            break;
          case 'ToggleButton':
            element.toggle = (element.value && element.value?.toLowerCase() == 'true') ? true : false;
            break;
        }
      }
    });
  }

  getAddedCustomAttributes(form) {
    return form.controls.customAttributeValues.controls;
  }

  addCustomAttribute(customAttribute: CasesAddEditCustomFields) {
    const control = <FormArray>this.casesForm.get('customAttributeValues');
    control.push(this.initCustomAttribute(customAttribute));
  }

  getCustomValidators(customAttribute: CasesAddEditCustomFields, formControlId: number): any[] {
    const validators = [];

    if (customAttribute?.isRequired && customAttribute.formControlId == formControlId) {
      validators.push(Validators.required);
    }

    return validators;
  }

  isRequiredTouched(control: FormGroup): boolean {
    return control?.invalid && control?.touched;
  }

  // Scroll to error handler function
  scrollToError(): void {
    const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
    this.scrollTo(firstElementWithError);

    if (!firstElementWithError) {
      const secondElementWithError = document.querySelector('.p-invalid');
      this.scrollTo(secondElementWithError);
    }
  }

  // Scroll to error element
  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  onCustomUpload(event, customField: FormGroup, type): void {
    for (let file of event.files) {
      let errors = [];
      this.appMainService.isShowSpinner('uploadFile');
      if (type == 'image') {
        errors = validateFiles(file, 2, this.allowedExtensions);
      } else {
        errors = validateFileSize(file, 2);
      }

      if (errors.length) {
        for (let error of errors) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error.fileName + ": " + error.error
          });
        }
        this.appMainService.isHideSpinner('uploadFile');
      } else {
        uploadFiles(file, ({ name, content, size, extension }) => {

          const customAttachment: casesCustomAttributeAttachment = {
            name: name,
            extension: extension,
            content: content,
            sizeInBytes: size
          }

          const addedAttachments = customField.value.customeAttachement || [];
          const alreadyAdded = addedAttachments.find(f => f.name === customAttachment.name);

          if (!alreadyAdded) {
            addedAttachments.push(customAttachment);
            customField.patchValue({
              customeAttachement: addedAttachments
            })
          } else {
            this.messageService.add({ severity: 'warn', summary: 'Exist', detail: `${customAttachment.name} already added.` });
          }

          this.appMainService.isHideSpinner('uploadFile');
        });
      }
    }
  }

  removeCustomFile(index: number, customField: FormGroup) {
    const addedAttachments = customField.value.customeAttachement || [];
    addedAttachments.splice(index, 1);
    customField.patchValue({
      customeAttachement: addedAttachments.length > 0 ? addedAttachments : null
    })
  }

  // downloadFile(name, content): void {
  //     this.fileService.downloadFile(name, content);
  // }

  // edit cases work
  setCasesFormDetails() {
    if (this.casesDetails?.attachments) {
      this.uploadedFiles = this.casesDetails?.attachments;
    }
    this.resolutionDate = new Date(this.casesDetails?.resolutionDate);
    const selectedCategory = this.categories.find(data => data?.name == this.casesDetails?.categoryName);
    this.categories = this.categories.filter((data) => data?.isActive == true || data?.name == this.casesDetails?.categoryName);
    this.subCategories = this.categoriesList?.length ? this.categoriesList.filter((category: Category) => category?.parentCategoryId === selectedCategory?.id) : [];
    this.subCategories = this.subCategories.filter((data) => data?.isActive == true || data?.name == this.casesDetails?.subCategoryName);
    const subCategory = this.subCategories.find(data => data?.name == this.casesDetails?.subCategoryName);

    this.casesForm.patchValue({
      id: this.casesDetails.id || 0,
      // channelId: (this.casesChannelList?.find(data=> data?.id == this.casesDetails?.channelId))?.id,
      caseAssociationName: this.caseAssociationList.find(data => data?.name == this.casesDetails?.caseAssociationName),
      associationName: { ...this.casesDetails?.associationData, businessName: this.casesDetails?.associationData?.name },
      contactName: { contactName: this.casesDetails?.contactName || "" },
      contactEmailAddress: { emailAddress: this.casesDetails?.contactEmailAddress || "" },
      contactMobileNo: { number: this.casesDetails?.contactMobileNo || "" },
      sourceName: this.sources.find(data => data?.id == this.casesDetails?.sourceId),
      categoryName: selectedCategory||null,
      subCategoryName: subCategory||null,
      priorityName: this.priorities.find(data => data?.id == this.casesDetails?.priorityId),
      subject: this.casesDetails?.subject || "",
      attachmentLinks: this.casesDetails?.attachments,
      reportedBy: this.casesDetails?.reportedBy || "",
      ticketDesc: this.casesDetails?.ticketDesc || "",
      resolutionDate: this.datePipe.transform(this.casesDetails?.resolutionDate, 'MM/dd/yyyy'),
      resolutionComment: this.casesDetails?.resolutionComment || "",
      assignedGroup: this.groupUserList.find(data => data?.id == this.casesDetails?.userGroupId),
      assignedUser: this.getUserList(this.groupUserList.find(data => data?.id == this.casesDetails?.userGroupId))?.find(data => data?.id == this.casesDetails?.userId),
    });
    if (this.crudType == 'update' || this.crudType == 'view') {
      this.casesForm.patchValue({
        sequenceNumber: this.casesDetails.sequenceNumber
      });
    }

    if(this.callFromAccountTab){
      this.casesForm.patchValue({
        channelId: (this.casesChannelList?.find(data=> data?.id == this.casesDetails?.channelId))?.id,
      });
    }
  }

  getUserList(selectedGroup) {
    return this.userList = selectedGroup?.users;
  }

  // View Cases Implementation
  generateCasesView() {
    const casesViewDetails = {
      id: this.casesDetails.id,
      sequenceNumber: this.casesDetails.sequenceNumber,
      caseAssociationName: this.casesDetails.caseAssociationName,
      associationName: this.casesDetails.associationName,
      contactName: this.casesDetails.contactName,
      contactEmailAddress: this.casesDetails.contactEmailAddress,
      contactMobileNo: this.casesDetails.contactMobileNo,
      sourceName: this.casesDetails.sourceName,
      categoryName: this.casesDetails.categoryName,
      subCategoryName: this.casesDetails.subCategoryName,
      priorityName: this.casesDetails.priorityName,
      subject: this.casesDetails.subject,
      // attachmentLinks: this.casesDetails.categoryName,
      reportedBy: this.casesDetails?.reportedBy || "",
      ticketDesc: this.casesDetails?.ticketDesc || "",
      resolutionDate: this.datePipe.transform(this.casesDetails?.resolutionDate, 'MM/dd/yyyy') || "",
      resolutionComment: this.casesDetails?.resolutionComment || "",
      assignedGroup: this.casesDetails?.assignedGroup,
      assignedUser: this.casesDetails?.assignedUser,
      customAttributeValues: this.casesDetails?.customAttributeValues,
      createdByUserName: this.casesDetails?.createdByUserName,
      createdDate: new LocalDatePipe().transform(this.casesDetails?.createdDate, 'MM/DD/YYYY'),
      currentStage: this.casesDetails?.currentStage,
      previousStage: this.casesDetails?.previousStage,
      stageChangedBy: this.casesDetails?.stageChangedBy,
      stageChangedDate: new LocalDatePipe().transform(this.casesDetails?.stageChangedDate,'MM/DD/YYYY'),
      channelId: this.casesDetails?.channelId,
      stageId: this.casesDetails?.stageId
    }

    this.formatCustomAttributeValues(casesViewDetails.customAttributeValues);
    this.casesViewDetails = casesViewDetails;
  }


  formatCustomAttributeValues(customAttributeValues = {}) {
    this.casesDetails?.customAttributeValues.map(customField => {
      let value = customField.value;

      switch (customField.formControlId) {
        case FormControlListIds.DatePicker:
          value = customField.value ? new DatePipe('en').transform(customField.value, 'MM/dd/yyyy') : '';
          break;
        case FormControlListIds.DropDownList:
          value = customField.values?.name || "";
          break;
        case FormControlListIds.MultipleDropDownList:
          value = customField.multipleValues?.length > 0 ? customField.multipleValues.map(val => val.name)?.join(', ') : "";
          break;
        case FormControlListIds.CheckBox:
          value = customField.multipleCheckBox?.length > 0 ? customField.multipleCheckBox.join(', ') : "";
          break;
        case FormControlListIds.Rating:
          value = customField.ratingId.toString();
          break;
        case FormControlListIds.ToggleButton:
          value = customField.toggle ? 'true' : 'false';
          break;
        case FormControlListIds.Picture:
          const pictures = customField.customeAttachement;
          if (pictures?.length) {
            value = pictures.filter(val => val?.name).map(val => val.name)?.join(',\n')
          } else {
            value = '';
          }
          break;
        case FormControlListIds.FileUpload:
          const files = customField.customeAttachement;
          if (files?.length) {
            value = files.filter(val => val?.name).map(val => val.name)?.join(',\n')
          } else {
            value = '';
          }
          break;
        default:
          break;
      }

      customAttributeValues[customField.customAttributeId] = value;
    })
  }

  switchToEdit() {
    this.crudType = 'update';
    this.dialogHeader = 'Edit Cases';
  }



  //#region ParentAccount

  chooseAccountCol() {
    let currentCaseAssociation = this.casesForm?.getRawValue()?.caseAssociationName;
    this.selectedModule = this.allModuleList.find(name=> name.name == currentCaseAssociation?.name);
    this.columnSettingsService.getColumnSettings(this.selectedModule?.id, this.accountChannelId).subscribe(
        resp => {
            let defaultColumnSettings: Partial<ColumnSettingsN> = ParseHelper.DeepCopy(resp);
            this.manualRuleColumnSetttings = defaultColumnSettings;
        },
        err => {
        }
    );
  }
  openParentAcountDialog() {
    this.chooseAccountCol();
    this.selectedRecordList = this.casesForm.value.associationName ? ParseHelper.DeepCopy([this.casesForm.value.associationName]) : [];
    this.displayManualPopup = true;
  }

  removeParentAccount() {
      this.selectedParentAccount = null;
      this.casesForm.patchValue({
        associationName: null
      })
  }

  saveParentAccount($event) {
      this.selectedRecordList = ParseHelper.DeepCopy($event.selectedReccords);
      if (this.selectedRecordList?.length > 0) {
          this.selectedParentAccount = ParseHelper.DeepCopy(this.selectedRecordList[0]);
          this.casesForm.patchValue({
            associationName: this.selectedParentAccount
          })
          this.getContactsValues(this.casesForm?.value?.associationName);
      }
      this.displayManualPopup = false;
  }

  columnSettingSaved($event){
      this.manualRuleColumnSetttings = $event;
  }

  manualpopupCancelClicked() {
      this.displayManualPopup = false;
  }
}


